"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _react = _interopRequireWildcard(require("react"));
var _styledComponents = _interopRequireWildcard(require("styled-components"));
var _Theme = _interopRequireDefault(require("../Theme"));
var _Text = _interopRequireDefault(require("../Text"));
var _Icon = _interopRequireDefault(require("../Icon"));
var _BigPointsCalculator = require("../BigPointsCalculator");
var _utilities = _interopRequireDefault(require("../../utilities"));
var _BigMemberSearch = _interopRequireDefault(require("./BigMemberSearch.proptypes"));
var _constant = require("./constant");
var _index = _interopRequireDefault(require("./SearchInput/index"));
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0, _defineProperty2.default)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
var ssoUserInfo = {};
var BigMemberIdWrapper = _styledComponents.default.div.withConfig({
  displayName: "BigMemberSearch__BigMemberIdWrapper",
  componentId: "sc-1b6hm5u-0"
})(["display:flex;align-items:center;padding-top:", ";"], function (_ref) {
  var theme = _ref.theme,
    newVersion = _ref.newVersion;
  return newVersion ? theme.space.XXXSmall : 0;
});
var HorizontalDivider = _styledComponents.default.div.withConfig({
  displayName: "BigMemberSearch__HorizontalDivider",
  componentId: "sc-1b6hm5u-1"
})(["height:32px;width:1px;border-right:1px solid ", ";margin:0 ", ";"], function (_ref2) {
  var theme = _ref2.theme;
  return theme.colors.greyLight;
}, function (_ref3) {
  var theme = _ref3.theme;
  return theme.space.small;
});
var MemberIcon = _styledComponents.default.div.withConfig({
  displayName: "BigMemberSearch__MemberIcon",
  componentId: "sc-1b6hm5u-2"
})(["width:auto;height:16px;"]);
var MemeberInfo = _styledComponents.default.div.withConfig({
  displayName: "BigMemberSearch__MemeberInfo",
  componentId: "sc-1b6hm5u-3"
})(["font-size:", ";line-height:", ";color:", ";"], function (_ref4) {
  var theme = _ref4.theme;
  return theme.fontSize.XSmall;
}, function (_ref5) {
  var theme = _ref5.theme;
  return theme.lineHeight.XSmall;
}, function (_ref6) {
  var theme = _ref6.theme;
  return theme.colors.greyDark;
});
var CaptionText = (0, _styledComponents.default)(_Text.default).withConfig({
  displayName: "BigMemberSearch__CaptionText",
  componentId: "sc-1b6hm5u-4"
})(["display:block;font-size:", ";line-height:", ";color:", ";font-weight:", ";"], function (_ref7) {
  var theme = _ref7.theme;
  return theme.fontSize.XSmall;
}, function (_ref8) {
  var theme = _ref8.theme;
  return theme.lineHeight.XSmall;
}, function (_ref9) {
  var theme = _ref9.theme;
  return theme.colors.greyDark;
}, function (_ref10) {
  var theme = _ref10.theme;
  return theme.fontWeight.medium;
});
var MemberIdText = (0, _styledComponents.default)(_Text.default).withConfig({
  displayName: "BigMemberSearch__MemberIdText",
  componentId: "sc-1b6hm5u-5"
})(["font-size:", ";line-height:", ";color:", ";font-weight:", ";"], function (_ref11) {
  var theme = _ref11.theme;
  return theme.fontSize.normal;
}, function (_ref12) {
  var theme = _ref12.theme;
  return theme.lineHeight.normal;
}, function (_ref13) {
  var color = _ref13.color;
  return color;
}, function (_ref14) {
  var theme = _ref14.theme;
  return theme.fontWeight.medium;
});
var BigMemberSearchWrapper = _styledComponents.default.div.withConfig({
  displayName: "BigMemberSearch__BigMemberSearchWrapper",
  componentId: "sc-1b6hm5u-6"
})(["box-shadow:", ";padding:", ";opacity:", ";pointer-events:", ";"], function (_ref15) {
  var newVersion = _ref15.newVersion;
  return !newVersion ? '0px 1px 4px rgba(0, 0, 0, 0.16)' : '';
}, function (_ref16) {
  var theme = _ref16.theme,
    newVersion = _ref16.newVersion;
  return !newVersion ? "".concat(theme.space.small) : "".concat(theme.space.XXXSmall, " ").concat(theme.space.small, " ").concat(theme.space.XXXSmall, " ").concat(theme.space.none);
}, function (_ref17) {
  var disableSearch = _ref17.disableSearch,
    newVersion = _ref17.newVersion;
  return disableSearch && !newVersion ? 0.5 : 1;
}, function (_ref18) {
  var disableSearch = _ref18.disableSearch,
    newVersion = _ref18.newVersion;
  return disableSearch && newVersion ? 'none' : 'auto';
});
var FormInfo = _styledComponents.default.div.withConfig({
  displayName: "BigMemberSearch__FormInfo",
  componentId: "sc-1b6hm5u-7"
})(["display:flex;align-items:center;flex-direction:", ";align-items:", ";"], function (_ref19) {
  var isMobile = _ref19.isMobile;
  return isMobile ? 'column-reverse' : 'row';
}, function (_ref20) {
  var isMobile = _ref20.isMobile;
  return isMobile ? 'flex-start' : 'center';
});
var FormHeading = _styledComponents.default.div.withConfig({
  displayName: "BigMemberSearch__FormHeading",
  componentId: "sc-1b6hm5u-8"
})(["flex:1;max-width:100%;flex-direction:column;display:flex;"]);
var FormTitleText = (0, _styledComponents.default)(_Text.default).withConfig({
  displayName: "BigMemberSearch__FormTitleText",
  componentId: "sc-1b6hm5u-9"
})(["font-size:", ";line-height:", ";"], function (_ref21) {
  var theme = _ref21.theme;
  return theme.fontSize.small;
}, function (_ref22) {
  var theme = _ref22.theme;
  return theme.lineHeight.large;
});
var FormSubTitleText = (0, _styledComponents.default)(_Text.default).withConfig({
  displayName: "BigMemberSearch__FormSubTitleText",
  componentId: "sc-1b6hm5u-10"
})(["font-size:", ";margin-top:", ";"], function (_ref23) {
  var theme = _ref23.theme,
    newVersion = _ref23.newVersion;
  return !newVersion ? theme.fontSize.small : theme.fontSize.XSmall;
}, function (_ref24) {
  var theme = _ref24.theme,
    newVersion = _ref24.newVersion;
  return !newVersion ? theme.space.micro : 0;
});
var BigLoyaltyIcon = _styledComponents.default.div.withConfig({
  displayName: "BigMemberSearch__BigLoyaltyIcon",
  componentId: "sc-1b6hm5u-11"
})(["margin:", ";"], function (_ref25) {
  var theme = _ref25.theme,
    isMobile = _ref25.isMobile;
  return isMobile ? "".concat(theme.space.tiny, " 0") : 0;
});
var BigLoyaltyContainer = _styledComponents.default.div.withConfig({
  displayName: "BigMemberSearch__BigLoyaltyContainer",
  componentId: "sc-1b6hm5u-12"
})([""]);
var DefaultContainer = _styledComponents.default.div.withConfig({
  displayName: "BigMemberSearch__DefaultContainer",
  componentId: "sc-1b6hm5u-13"
})(["display:flex;flex-direction:row;"]);
var TextContainer = _styledComponents.default.div.withConfig({
  displayName: "BigMemberSearch__TextContainer",
  componentId: "sc-1b6hm5u-14"
})(["display:flex;align-items:center;"]);
var IconContainer = _styledComponents.default.div.withConfig({
  displayName: "BigMemberSearch__IconContainer",
  componentId: "sc-1b6hm5u-15"
})(["display:flex;padding-right:", ";"], function (_ref26) {
  var theme = _ref26.theme;
  return theme.space.tiny;
});
var ArrowContainer = _styledComponents.default.div.withConfig({
  displayName: "BigMemberSearch__ArrowContainer",
  componentId: "sc-1b6hm5u-16"
})(["display:flex;padding-left:", ";"], function (_ref27) {
  var theme = _ref27.theme;
  return theme.space.small;
});
var LoadingContainer = _styledComponents.default.div.withConfig({
  displayName: "BigMemberSearch__LoadingContainer",
  componentId: "sc-1b6hm5u-17"
})(["display:flex;padding-top:", ";padding-left:", ";"], function (_ref28) {
  var theme = _ref28.theme;
  return theme.space.XSmall;
}, function (_ref29) {
  var theme = _ref29.theme;
  return theme.space.small;
});
var BigMemberSearch = function BigMemberSearch(_ref30) {
  var disableSearch = _ref30.disableSearch,
    loyaltyId = _ref30.loyaltyId,
    loyaltyTier = _ref30.loyaltyTier,
    placeholder = _ref30.placeholder,
    onClickSearch = _ref30.onClickSearch,
    errorMessage = _ref30.errorMessage,
    initialValue = _ref30.initialValue,
    theme = _ref30.theme,
    translation = _ref30.translation,
    accessible = _ref30.accessible,
    isMobile = _ref30.isMobile,
    newVersion = _ref30.newVersion,
    bigLoyaltyAlt = _ref30.bigLoyaltyAlt,
    defaultToggle = _ref30.defaultToggle,
    onToggle = _ref30.onToggle,
    isLoading = _ref30.isLoading,
    environment = _ref30.environment,
    firstName = _ref30.firstName,
    lastName = _ref30.lastName,
    totalPoints = _ref30.totalPoints,
    onSubmit = _ref30.onSubmit,
    email = _ref30.email,
    dateOfBirth = _ref30.dateOfBirth,
    apiKey = _ref30.apiKey,
    clientId = _ref30.clientId,
    hasChanges = _ref30.hasChanges,
    handleField = _ref30.handleField,
    isLoggedInUser = _ref30.isLoggedInUser;
  var themeContext = (0, _react.useContext)(_styledComponents.ThemeContext);
  var bigMemberId = translation.bigMemberId,
    formTitle = translation.formTitle,
    formSubTitle = translation.formSubTitle,
    search = translation.search,
    invalidEmailMessage = translation.invalidEmailMessage,
    earnBigPointsGuest = translation.earnBigPointsGuest,
    searchSubtitle = translation.searchSubtitle,
    earnUpTo = translation.earnUpTo,
    points = translation.points,
    detailedInvalidEmailMessage = translation.detailedInvalidEmailMessage,
    noData = translation.noData,
    unavailable = translation.unavailable;
  var bigPointsContext = (0, _BigPointsCalculator.useBigPointsCalculatorContext)();
  var isShowMemberId = loyaltyId && loyaltyTier && _constant.MEMBER_TYPES.includes(loyaltyTier);
  var _useState = (0, _react.useState)(loyaltyId || ''),
    _useState2 = (0, _slicedToArray2.default)(_useState, 2),
    memberId = _useState2[0],
    setLoyaltyId = _useState2[1];
  var _useState3 = (0, _react.useState)(loyaltyTier || ''),
    _useState4 = (0, _slicedToArray2.default)(_useState3, 2),
    memberTier = _useState4[0],
    setLoyaltyTier = _useState4[1];
  var _useState5 = (0, _react.useState)(false),
    _useState6 = (0, _slicedToArray2.default)(_useState5, 2),
    newVersionShowId = _useState6[0],
    setShowMemberId = _useState6[1];
  var _useState7 = (0, _react.useState)(false),
    _useState8 = (0, _slicedToArray2.default)(_useState7, 2),
    loading = _useState8[0],
    setIsLoading = _useState8[1];
  var _useState9 = (0, _react.useState)(''),
    _useState10 = (0, _slicedToArray2.default)(_useState9, 2),
    inputErrorMessage = _useState10[0],
    setErrorMessage = _useState10[1];
  var _useState11 = (0, _react.useState)(initialValue || ''),
    _useState12 = (0, _slicedToArray2.default)(_useState11, 2),
    inputValue = _useState12[0],
    setInputValue = _useState12[1];
  var _useState13 = (0, _react.useState)(false),
    _useState14 = (0, _slicedToArray2.default)(_useState13, 2),
    loadingOnly = _useState14[0],
    setIsLoadingOnly = _useState14[1];
  var MemberIconSVG = _constant.MEMBER_ICONS[loyaltyTier];
  var BigLoyaltyIconSVG = _constant.BIGLOYALTY_ICON;
  var _useState15 = (0, _react.useState)(defaultToggle || false),
    _useState16 = (0, _slicedToArray2.default)(_useState15, 2),
    toggleClicked = _useState16[0],
    setToggleClicked = _useState16[1];
  // const isNewVersion = noSearch && newVersion;
  var isValidDob = dateOfBirth !== '' && _constant.BIGMEMBER_DOB_REGEX.test(dateOfBirth);
  var isValidEmail = email !== '';
  var _useState17 = (0, _react.useState)({
      firstName: '',
      lastName: '',
      dateOfBirth: ''
    }),
    _useState18 = (0, _slicedToArray2.default)(_useState17, 2),
    previousValues = _useState18[0],
    setPreviousValues = _useState18[1];
  // const [hasFetchedData, setHasFetchedData] = useState(false);

  var formatDateOfBirth = function formatDateOfBirth(dob) {
    if (!dob) return '';
    var _dob$split = dob.split('-'),
      _dob$split2 = (0, _slicedToArray2.default)(_dob$split, 3),
      year = _dob$split2[0],
      month = _dob$split2[1],
      day = _dob$split2[2];
    return "".concat(day).concat(month).concat(year);
  };
  (0, _react.useEffect)(function () {
    // Check if any of the values have changed
    var allFieldsFilled = firstName !== '' && lastName !== '' && dateOfBirth !== '' && isValidDob;
    if (hasChanges && allFieldsFilled && (firstName !== previousValues.firstName || lastName !== previousValues.lastName || dateOfBirth !== previousValues.dateOfBirth) && (isValidDob || isValidEmail)) {
      fetchData(inputValue);
      setPreviousValues({
        firstName: firstName,
        lastName: lastName,
        dateOfBirth: dateOfBirth
      });
    }
  }, [firstName, lastName, dateOfBirth, hasChanges, inputValue, fetchData, email, previousValues, isValidDob, isValidEmail]);
  (0, _react.useEffect)(function () {
    if (isLoggedInUser && firstName !== '' && lastName !== '' && (isValidDob !== '' || isValidEmail)) {
      fetchData(inputValue);
    }
    if (loyaltyId != null || memberId != null) {
      fetchData(inputValue);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  var renderIcon = function renderIcon(color, fontsize, icon) {
    return /*#__PURE__*/_react.default.createElement(ArrowContainer, {
      onClick: function onClick() {
        setToggleClicked(!toggleClicked);
        if (onToggle) onToggle();
      }
    }, /*#__PURE__*/_react.default.createElement(_Icon.default, {
      color: color,
      fontsize: fontsize,
      icon: icon,
      theme: theme
    }));
  };
  var getApiVersionUrl = function getApiVersionUrl() {
    return _constant.ENVIRONMENT_URL.v1[environment].NAV_URL;
  };
  var getHeaders = function getHeaders() {
    return {
      'x-api-key': apiKey,
      'x-aa-client-id': clientId
    };
  };
  var formatApiParams = function formatApiParams(url, value) {
    var formattedUrl = "".concat(url, "?firstName=").concat(encodeURIComponent(firstName), "&lastName=").concat(encodeURIComponent(lastName));
    var formattedDateOfBirth = formatDateOfBirth(dateOfBirth);
    formattedUrl += isLoggedInUser ? "&username=".concat(inputValue) : "&dateOfBirth=".concat(encodeURIComponent(formattedDateOfBirth));
    return formattedUrl;
  };
  function fetchDataWithEmail(_x) {
    return _fetchDataWithEmail.apply(this, arguments);
  } // eslint-disable-next-line react-hooks/exhaustive-deps
  function _fetchDataWithEmail() {
    _fetchDataWithEmail = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee(value) {
      var url, headersValue, result;
      return _regenerator.default.wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            setInputValue(value);
            setIsLoadingOnly(true);
            setShowMemberId(false);
            url = "".concat(getApiVersionUrl(), "?firstName=").concat(encodeURIComponent(firstName), "&lastName=").concat(encodeURIComponent(lastName), "&username=").concat(value);
            headersValue = _objectSpread({
              Origin: _constant.ORIGIN_URL[environment].NAV_URL
            }, getHeaders());
            _context.prev = 5;
            _context.next = 8;
            return _utilities.default.get(url, headersValue);
          case 8:
            result = _context.sent;
            if (result && (result.loyaltyId && result.loyaltyTier || result.memberId)) {
              setIsLoadingOnly(false);
              setShowMemberId(true);
              setLoyaltyId(result.loyaltyId || result.memberId);
              setLoyaltyTier(result.loyaltyTier);
              setIsLoading(false);
              handleField({
                bigMemberId: result.loyaltyId || result.memberId
              });
              handleField({
                encryptedKey: result.encrypted
              });
            }
            if (!(result && result.code === _constant.MISMATCH_ERROR)) {
              _context.next = 18;
              break;
            }
            setIsLoadingOnly(false);
            setShowMemberId(false);
            setErrorMessage(noData);
            setLoyaltyId('');
            handleField({
              bigMemberId: ''
            });
            handleField({
              encryptedKey: ''
            });
            return _context.abrupt("return", null);
          case 18:
            return _context.abrupt("return", null);
          case 21:
            _context.prev = 21;
            _context.t0 = _context["catch"](5);
            setIsLoadingOnly(false);
            setShowMemberId(false);
            setErrorMessage(noData);
            setLoyaltyId('');
            handleField({
              bigMemberId: ''
            });
            handleField({
              encryptedKey: ''
            });
            return _context.abrupt("return", null);
          case 30:
          case "end":
            return _context.stop();
        }
      }, _callee, null, [[5, 21]]);
    }));
    return _fetchDataWithEmail.apply(this, arguments);
  }
  function fetchData(_x2) {
    return _fetchData.apply(this, arguments);
  }
  function _fetchData() {
    _fetchData = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee2(value) {
      var url, headersValue, result;
      return _regenerator.default.wrap(function _callee2$(_context2) {
        while (1) switch (_context2.prev = _context2.next) {
          case 0:
            setInputValue(value);
            setIsLoadingOnly(true);
            url = formatApiParams(getApiVersionUrl(), value);
            headersValue = _objectSpread({
              Origin: _constant.ORIGIN_URL[environment].NAV_URL
            }, getHeaders());
            _context2.prev = 4;
            _context2.next = 7;
            return _utilities.default.get(url, headersValue);
          case 7:
            result = _context2.sent;
            if (result && (result.loyaltyId && result.loyaltyTier || result.memberId)) {
              setIsLoadingOnly(false);
              setShowMemberId(true);
              setLoyaltyId(result.loyaltyId || result.memberId);
              setLoyaltyTier(result.loyaltyTier);
              setIsLoading(false);
              handleField({
                bigMemberId: result.loyaltyId || result.memberId
              });
              handleField({
                encryptedKey: result.encrypted
              });
            }
            if (!(!isLoggedInUser && result.size > 1)) {
              _context2.next = 17;
              break;
            }
            setIsLoadingOnly(false);
            setShowMemberId(false);
            setErrorMessage(noData);
            setLoyaltyId('');
            handleField({
              bigMemberId: ''
            });
            handleField({
              encryptedKey: ''
            });
            return _context2.abrupt("return", null);
          case 17:
            if (!(result && result.code === _constant.MISMATCH_ERROR)) {
              _context2.next = 25;
              break;
            }
            setIsLoadingOnly(false);
            setShowMemberId(false);
            setErrorMessage(noData);
            setLoyaltyId('');
            handleField({
              bigMemberId: ''
            });
            handleField({
              encryptedKey: ''
            });
            return _context2.abrupt("return", null);
          case 25:
            return _context2.abrupt("return", null);
          case 28:
            _context2.prev = 28;
            _context2.t0 = _context2["catch"](4);
            setIsLoadingOnly(false);
            setShowMemberId(false);
            setErrorMessage(noData);
            setLoyaltyId('');
            handleField({
              bigMemberId: ''
            });
            handleField({
              encryptedKey: ''
            });
            return _context2.abrupt("return", null);
          case 37:
          case "end":
            return _context2.stop();
        }
      }, _callee2, null, [[4, 28]]);
    }));
    return _fetchData.apply(this, arguments);
  }
  var handleSearchClick = function handleSearchClick() {
    if (isValidEmail && inputValue) {
      fetchDataWithEmail(inputValue);
    }
  };
  var renderSearch = function renderSearch() {
    var disabledSearchOldVersion = !disableSearch && !newVersion;
    return /*#__PURE__*/_react.default.createElement(_index.default, {
      accessible: accessible,
      initialValue: initialValue,
      placeholder: placeholder,
      translation: {
        search: search,
        invalidEmailMessage: invalidEmailMessage,
        detailedInvalidEmailMessage: detailedInvalidEmailMessage,
        noData: noData
      },
      onClickSearch: disabledSearchOldVersion ? onClickSearch : newVersion && handleSearchClick,
      errorMessage: disabledSearchOldVersion ? errorMessage : newVersion && inputErrorMessage,
      newVersion: newVersion,
      disabled: disableSearch,
      onChangeEmail: function onChangeEmail(value) {
        setInputValue(value);
      }
    });
  };

  // const renderNoSearch = () => {
  //   return (
  //     <Text
  //       accessible={accessible}
  //       theme={theme}
  //       display={TEXT.inlineFlex}
  //       color={TEXT.primary}
  //       hasToggle={false}
  //       type={TEXT.small}
  //     >
  //       {inputErrorMessage}
  //     </Text>
  //   );
  // };

  var renderSearchWrapper = function renderSearchWrapper() {
    return renderSearch();
  };
  var returnBigMemberSearchWrapper = function returnBigMemberSearchWrapper() {
    return /*#__PURE__*/_react.default.createElement(BigMemberSearchWrapper, {
      disableSearch: disableSearch,
      newVersion: newVersion
    }, /*#__PURE__*/_react.default.createElement(FormInfo, {
      isMobile: isMobile
    }, /*#__PURE__*/_react.default.createElement(FormHeading, null, !newVersion ? /*#__PURE__*/_react.default.createElement(FormTitleText, {
      accessible: false,
      color: _constant.TEXT.greyDarker,
      bold: true
    }, formTitle) : null, (!disableSearch && !newVersion || newVersion) && /*#__PURE__*/_react.default.createElement(FormSubTitleText, {
      accessible: false,
      color: _constant.TEXT.greyDark,
      newVersion: newVersion
    }, newVersion ? searchSubtitle : formSubTitle)), !newVersion ? /*#__PURE__*/_react.default.createElement(BigLoyaltyIcon, {
      isMobile: isMobile,
      alt: _constant.TEXT.icon
    }, /*#__PURE__*/_react.default.createElement(BigLoyaltyIconSVG, null)) : null), renderSearchWrapper());
  };
  var returnBigMemberIdWrapper = function returnBigMemberIdWrapper() {
    return /*#__PURE__*/_react.default.createElement(BigMemberIdWrapper, {
      newVersion: newVersion
    }, /*#__PURE__*/_react.default.createElement(MemeberInfo, null, /*#__PURE__*/_react.default.createElement(CaptionText, {
      accessible: false
    }, bigMemberId), /*#__PURE__*/_react.default.createElement(MemberIdText, {
      accessible: false,
      color: _constant.TEXT.neutral
    }, memberId)), /*#__PURE__*/_react.default.createElement(HorizontalDivider, null), isLoading ? /*#__PURE__*/_react.default.createElement("img", {
      src: _constant.LOADING_GIF,
      alt: _constant.TEXT.loading,
      width: _constant.TEXT.size,
      height: _constant.TEXT.size
    }) : /*#__PURE__*/_react.default.createElement(MemeberInfo, null, /*#__PURE__*/_react.default.createElement(CaptionText, {
      accessible: false
    }, earnUpTo), /*#__PURE__*/_react.default.createElement(MemberIdText, {
      accessible: false,
      color: bigPointsContext && bigPointsContext.points ? _constant.TEXT.neutral : _constant.TEXT.unavailableColor
    }, bigPointsContext && bigPointsContext.points && newVersion ? "".concat(bigPointsContext.points, " ").concat(points) : unavailable))
    // : (
    //   <MemberIcon alt={loyaltyTier}>
    //     <MemberIconSVG />
    //   </MemberIcon>
    // )
    );
  };

  var getNewMain = function getNewMain() {
    // eslint-disable-next-line no-unused-expressions
    return /*#__PURE__*/_react.default.createElement(BigLoyaltyContainer, null, /*#__PURE__*/_react.default.createElement(DefaultContainer, null, /*#__PURE__*/_react.default.createElement(IconContainer, null, /*#__PURE__*/_react.default.createElement("img", {
      src: _constant.BIG_LOYALTY_MONOGRAM,
      alt: bigLoyaltyAlt !== '' ? bigLoyaltyAlt : _constant.BIG_LOYALTY_MONOGRAM_ALT
    })), /*#__PURE__*/_react.default.createElement(TextContainer, null, /*#__PURE__*/_react.default.createElement(_Text.default, {
      accessible: accessible,
      theme: theme,
      display: _constant.TEXT.inlineFlex,
      color: _constant.TEXT.greyDarker,
      hasToggle: false,
      type: _constant.TEXT.small
    }, earnBigPointsGuest)), renderIcon(_constant.ICONS.COLOR, _constant.ICONS.SIZE, toggleClicked ? _constant.ICONS.ICON_NAMES.EXPAND_LESS_ICON : _constant.ICONS.ICON_NAMES.EXPAND_MORE_ICON, _constant.DEFAULT_THEME)), toggleClicked && !newVersionShowId && !loadingOnly ? returnBigMemberSearchWrapper() : null, toggleClicked && newVersionShowId && !loadingOnly ? returnBigMemberIdWrapper() : null, loadingOnly ? /*#__PURE__*/_react.default.createElement(LoadingContainer, null, /*#__PURE__*/_react.default.createElement("img", {
      src: _constant.LOADING_GIF,
      alt: _constant.TEXT.loading,
      width: _constant.TEXT.size,
      height: _constant.TEXT.size
    })) : null);
  };
  var getMain = function getMain() {
    if (newVersion) {
      return getNewMain();
      // eslint-disable-next-line no-else-return
    } else {
      if (isShowMemberId) {
        return /*#__PURE__*/_react.default.createElement(BigMemberIdWrapper, null, /*#__PURE__*/_react.default.createElement(MemeberInfo, null, /*#__PURE__*/_react.default.createElement(CaptionText, {
          accessible: false
        }, bigMemberId), /*#__PURE__*/_react.default.createElement(MemberIdText, {
          accessible: false,
          color: _constant.TEXT.neutral
        }, loyaltyId)), /*#__PURE__*/_react.default.createElement(HorizontalDivider, null), /*#__PURE__*/_react.default.createElement(MemberIcon, {
          alt: loyaltyTier
        }, /*#__PURE__*/_react.default.createElement(MemberIconSVG, null)));
      }
      return returnBigMemberSearchWrapper();
    }
  };
  return themeContext ? getMain() : /*#__PURE__*/_react.default.createElement(_Theme.default, {
    theme: theme
  }, getMain());
};
BigMemberSearch.propTypes = _BigMemberSearch.default.PropTypes;
BigMemberSearch.defaultProps = _BigMemberSearch.default.DefaultProps;
var _default = BigMemberSearch;
exports.default = _default;